import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconPackageValidation from '@/icons/PackageValidation.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import { useArticleName } from '@/models/article';
import type { TNotificationOfType } from '@/models/notification';

export const ShipmentIssueResolvedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'shipment_issue_resolved'>;
}) => {
  const { t } = useLingui();
  const articleName = useArticleName({ article: notification.article });

  return (
    <BaseNotification
      icon={<IconPackageValidation />}
      type="primary"
      notification={notification}
      notificationLabel={t({
        id: 'notification.shipment-issue-resolved.label',
        message: `Shipment issue resolved for item ${articleName} of request ${notification.request.reference}`,
      })}
      notificationHeader={(color) => (
        <Trans id="notification.shipment-issue-resolved">
          The shipment issue reported on the item{' '}
          <InlineText weight="medium" color={color}>
            {articleName}
          </InlineText>{' '}
          has been resolved
        </Trans>
      )}
    />
  );
};
